import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import QuestionAnsbot from "./QuestionAnsbot";

const Answerbot = () => {
  const [webUrl, setWebUrl] = useState("https://www.google.com");
  const [selectedFaq, setSelectedFaq] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [faqs, setFaqs] = useState([
    {
      id: 1,
      question: "What feedback options are available?",
      answer: "You can provide feedback on various aspects such as predictions, search results, and app performance.",
      variations: 10,
      approved: false,
      expanded: false,
    },
    {
      id: 2,
      question: "How do I report inappropriate predictions?",
      answer: "",
      variations: 10,
      approved: false,
      expanded: false,
    },
    {
      id: 3,
      question: "How to change feedback settings?",
      answer: "",
      variations: 10,
      approved: false,
      expanded: false,
    },
  ]);

  const toggleExpand = (id) => {
    setFaqs(
      faqs.map((faq) =>
        faq.id === id ? { ...faq, expanded: !faq.expanded } : faq
      )
    );
  };

  const handleApprove = (id) => {
    setFaqs(
      faqs.map((faq) =>
        faq.id === id ? { ...faq, approved: !faq.approved } : faq
      )
    );
  };

  const openDrawer = (faq) => {
    setSelectedFaq(faq);
    setDrawerOpen(true);
  };

  const updateAnswer = (id, updatedAnswer) => {
    setFaqs(
      faqs.map((faq) =>
        faq.id === id ? { ...faq, answer: updatedAnswer } : faq
      )
    );
  };

  return (
    <div className="container mt-2">
      <div className="card p-4">
        <h4>AnswerBot</h4>
        <p>
          Import FAQs from your website within minutes so that your customers don't have to wait long to get answers.
        </p>
        <div className="alert alert-primary">
          In Sandbox mode, utilize a single web URL input for a one-time scan. <a href="###">Upgrade Plan</a>
        </div>
        <div className="mb-3">
          <label className="form-label">Web URL</label>
          <input
            type="text"
            className="form-control"
            value={webUrl}
            onChange={(e) => setWebUrl(e.target.value)}
          />
        </div>
        <button className="btn btn-secondary" disabled>
          Generate FAQs
        </button>
      </div>

      <div className="card p-4 mt-4">
        <h5>Explore the list below to see the FAQs I've generated for your website.</h5>
        <p>Customize and enhance them to guarantee a seamless customer experience.</p>
        <ul className="list-group">
          {faqs.map((faq) => (
            <div key={faq.id} className="border p-2 my-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <input
                    type="checkbox"
                    checked={faq.approved}
                    onChange={() => handleApprove(faq.id)}
                    className="me-2"
                  />
                  <strong>{faq.question}</strong>{" "}
                  <span className="text-primary">+{faq.variations} variations</span>
                </div>
                <button className="btn btn-sm btn-outline-primary" onClick={() => toggleExpand(faq.id)}>
                  {faq.expanded ? "-" : "+"}
                </button>
              </div>

              {faq.expanded && (
                <div className="mt-2">
                  <p>{faq.answer || "No answer available yet."}</p>
                  <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => openDrawer(faq)}>
                    Edit
                  </button>
                  <button className="btn btn-sm btn-success" onClick={() => handleApprove(faq.id)}>
                    Approve this answer
                  </button>
                </div>
              )}
            </div>
          ))}
        </ul>
        <div className="d-flex justify-content-end mt-3">
          <button className="btn btn-outline-secondary me-2">Complete without saving</button>
          <button className="btn btn-secondary" disabled>Save approved FAQs</button>
        </div>
      </div>

      {drawerOpen && selectedFaq && (
        <QuestionAnsbot
          faq={selectedFaq}
          onClose={() => setDrawerOpen(false)}
          onUpdate={updateAnswer}
        />
      )}
    </div>
  );
};

export default Answerbot;